export default "__VITE_ASSET__C5Ok0N7H__"